<template>
      <a-col>
        <div class="provisioning_agree_container">
          <div>
            <p>本服務條款為和泰汽車（以下稱「本公司」） HINO iTRAQ車聯管理系統網頁版（以下稱「本網站」）提供您服務的同時，您必須了解的重要事項。為保障您的權益及讓您合法使用本網站相關服務，請於註冊成為本網站會員前詳細閱讀本服務條款內容。當您確認並點選「我同意」按鍵，即表示您已同意並遵守本服務條款及相關法律規定，並可開始使用本網站所提供之服務。</p>
            <p>如果您無法遵守本服務條款內容，或不同意本服務條款內容時，請您立即停止使用本網站。為確保您的權益，建議您經常確認本服務條款之最新內容。</p>
            <p>由於本公司提供之服務範圍相當廣泛，可能會要求您檢視並同意您與特定軟體、產品、媒體或服務之互動關係的附加條款，若該附加條款與本服務條款有所抵觸者，則您對軟體、產品、媒體或服務的使用仍受該附加條款之規範。</p>
          </div>
          <div class="item">
            <h3>遵守服務條款及法律規定</h3>
            <p>當您註冊成為會員後，即可使用本網站提供的服務。您使用本網站服務時，視為已同意接受本服務條款及所有注意事項之拘束，並同意遵守中華民國相關法規及一切國際網際網路規定與慣例。</p>
            <p>*為確保您的行車安全，開車期間請勿操作或嘗試操作本網站，以免造成意外事故發生。</p>
          </div>   
          <div class="item">
            <h3>會員資料之修改與刪除</h3>
            <p>基於本網站所提供之各項服務，您同意於註冊時提供正確詳實之個人資料，若您所登錄之資料事後有變更時，應隨時於本網站上進行更新，表明您有意修改或刪除個人資料，本公司即會按您的要求作出變更。您提供之個人資料若有填寫不實或原登錄之資料已不符而未更新，或您提供之個人資料違反或破壞本公司服務宗旨，本公司保留隨時終止您的會員資格及使用各項服務之權利。如有任何虛假或冒用他人名義登錄，您應自負法律責任。</p>
          </div>       
          <div class="item">
            <h3>會員服務的有效性和使用效期</h3>
            <ul style="list-style: decimal; padding-left: 18px;">
              <li>本網站服務是由相對應的連網服務而訂定。以交車時且完成會員註冊當天視為連網服務開通日，享有3年之免費基本服務期限；若未於交車日完成會員註冊，則以交車日作為3年免費基本服務啟用日，於3年基本服務期滿後，可視當時之服務條款進行有償之續約。為保障您的服務及權益，請務必於交車日完成會員註冊，若長時間未註冊會員，將影響部分功能無法順利使用。</li>
              <li>本網站服務是藉由安裝於座車上的SIM卡訊號連網所提供，因此服務內容的發送和接收品質，可能因車輛所在地、網路供應商之基地台與訊號涵蓋範圍而有所差異，亦也有可能會受到氣壓狀態、地形條件和座車停放位置及空間障礙物（如橋樑、建築物）而影響。安裝於座車的SIM卡能正常運作和處於具連網能力之待命狀態是本網站得提供服務的必要條件。安裝於座車的SIM卡，不提供電話通訊服務，並在既有硬體的規格之下，僅提供終端主機與雲端系統的通訊使用。其他非正常之使用情況，將認定使用者違規使用，本公司有權隨時終止您的會員資格及使用各項服務之權利。</li>
              <li>本網站服務是藉由安裝於座車的終端主機，透過與車體系統的連結，提供多樣的資訊供使用者進行管理。終端主機運作時，會有資料處理的作業程序，並經由4G網絡將整理後的資料上傳至雲端系統，故在本網站檢閱車輛資訊時，可能會有與即時實車資訊內容存有部分差異。此非屬瑕疵，請您見諒。</li>
              <li>本網站服務可能因不可抗力之因素（包含但不限於；罷工、停工、官方命令以及本公司設備、交通資訊提供者或是其它服務商之保養、維修、系統更新和擴充）而導致暫時中斷，也可能因本網站服務之最大負荷量或是第三方電信系統故障而中斷，本公司承諾於各種合理情況內排除干擾並全力維護。</li>
              <li>您僅得於本公司販售之指定車輛使用本網站服務，且不可轉讓另一部車輛或是於另一部車輛使用，並禁止將本網站服務用於不合法之用途，亦禁止將本網站服務轉讓第三方或將與本網站服務相關的資料與資訊用於商業意圖。</li>
              <li>當您欲出售已啟用本網站會員服務之車輛時，本網站服務亦不得留用、使用權將隨車進行轉移，您僅能查閱擁有車輛時期的歷史資料。</li>
              <li>一旦您將車輛出售或永久轉讓予第三方，必需確保已將原會員帳號與車輛的連結解除綁定，並於車輛辦理過戶後親至全台HINO服務中心進行車輛資料更新，以利下任車主使用本網站服務功能。</li>
              <li>本公司預設以車機搭配雲端系統提供本網站服務，您不應以任何方式對車機進行軟硬體之破解、還原工程、解編或反向組譯等操作，亦不得以任何方式下載、傳輸、複製任何非本網站內建之應用程式，若進行任何可能破壞、毀損、阻止或妨礙其他使用者正常使用本網站服務之行為，本公司保留隨時終止您會員資格及使用各項服務之權利。此外，若您因前述違約行為，造成本網站服務無法正常運作或有侵害非本網站內建應用程式智慧財產權之不法行為，您須自行負擔相關法律責任，不得向本公司請求任何補償或賠償。</li>
            </ul>
          </div> 
          <div class="item">
            <h3>網站服務內容</h3>
            <ul style="list-style: decimal; padding-left: 18px;">
              <li>
                <p>基本說明</p>
                <p>本公司提供之「HINO iTRAQ車聯管理系統」藉由座車上安裝之4G SIM卡提供連網服務、4G通訊數據費用已包含於會員服務費用中（首3年不另外收費，3年期滿後視當時續約條件而定）。</p>
              </li>
              <li>
                <p>服務啟用</p>
                <p>車輛完成交車且您完成本網站會員註冊及開通服務後，即可啟用HINO iTRAQ車聯管理系統服務。</p>
              </li>
              <li>
                <p>服務功能-網頁WEB版</p>
                <ul style="list-style: none; padding-left: 0px;">
                  <li>
                    <p>（1） 即時監控 – 監控地圖</p>
                    <p>本功能提供所有登錄車輛之行車動態，包含車輛的行駛、怠速、熄火等狀態。能觀看車輛當前所在地點，當前車輛行駛方向、車速等即時資訊。當車輛有裝載原廠授權安裝的各類輔助功能主機設備，並能與本網站的終端主機串接時，將於監控地圖功能進行輔助資訊的查閱。</p>
                  </li>
                  <li>
                    <p>（2） 即時監控 – 即時影像</p>
                    <p>當會員欲觀看單一車輛現場實際的動態情況，可使用「即時影像」功能，透過網頁觀看車輛行車情況。</p>
                  </li>
                  <li>
                    <p>（3） 即時監控 – 語音訊息</p>
                    <p>當管理人員欲與某一駕駛人員進行工作任務討論時，可透過語音訊息功能進行錄音發話，便利駕駛人員查收工作要點，並能與管理群組即時溝通。</p>
                  </li>
                  <li>
                    <p>（4） 歷史查詢 – 軌跡回放</p>
                    <p>會員使用本功能即可隨時查閱車輛行駛歷程。行駛歷程內容包含每一行程段的啟動、熄火時間、行程所累積的里程數、行程的起迄地點、行駛中所發生的每項事件通知及車輛行進的軌跡路線，幫助管理行車計劃並有效節約行車花銷。</p>
                  </li>
                  <li>
                    <p>（5） 任務派遣 – 任務管理</p>
                    <p>本功能提供管理人員便捷的進行工作任務的建立，並能預估每個工作任務所需的行車時間，還能實時掌握任務執行的進度是否如預期。</p>
                  </li>
                  <li>
                    <p>（6） 數據中心 – 事件列表</p>
                    <p>當車輛於駕駛運行過程時，本功能將記錄每段行程中駕駛人員各種操駕動作的執行情況，如電子圍籬進出、車輛急加減速、車輛超速、車道偏移警示、車輛碰撞預警等事件，並於發生事件時都將留存於雲端系統，以供備查。</p>
                  </li>
                  <li>
                    <p>（7） 數據中心 – 營運月報</p>
                    <p>會員透過數據報告分析，能迅速掌握全體車輛工作時間的稼動比率以及工作任務的執行比率，並能精確計算，所有車輛的里程數據、油耗數據、還有平日保養維修花費的概況資訊。</p>
                  </li>
                  <li>
                    <p>（8） 保修系統 – 保修列表</p>
                    <p>當會員啟用本功能後，使用「保修列表」中的「預約原廠」功能，即可在線進行HINO原廠保養廠的預約作業。本網站亦定期更新車輛的維修工單記錄，讓管理人員能便利查閱車輛保養情況。</p>
                  </li>
                  <li>
                    <p>（9） 保修系統 – 保修週期</p>
                    <p>當會員啟用本功能後，可於「保修週期」功能中，設定所有車輛或單一車輛的保養通知，讓管理人員不會漏於追蹤或記錄車輛的保養情況。</p>
                  </li>
                  <li>
                    <p>（10） 車隊管理 – 車輛管理</p>
                    <p>當會員啟用本功能後，會員只須輸入基本資料，便可將已開通服務之車輛快速新增建入於本網站中，進而開始追蹤管理車輛的各項資訊。</p>
                  </li>
                  <li>
                    <p>（11） 車隊管理 – 帳號管理</p>
                    <p>當會員啟用本功能後，可使用手機號碼新增建立「管理人員」所使用的帳號，該手機號碼的使用者將收到一封通知簡訊，於查閱驗證簡訊內容後，帳號即建立完成。</p>
                  </li>
                  <li>
                    <p>（12） 車隊管理 – 駕駛管理</p>
                    <p>當會員啟用本功能後，可使用手機號碼新增建立「駕駛人員」所使用的帳號，該手機號碼的使用者將收到一封通知簡訊，於查閱驗證簡訊內容後，帳號即建立完成。</p>
                  </li>
                  <li>
                    <p>（13） 車隊管理 - 圍籬管理</p>
                    <p>會員啟用本功能即可於監控地圖上設定車輛使用的電子圍籬記號，當車輛行經圍籬時將會觸發進出圍籬事件通知，並可搭配任務派遣功能運用，達到工作執行的即時動態。</p>
                  </li>
                  <li>
                    <p>（14） 系統設定 – 參數設定</p>
                    <p>於本網站的「參數設定」功能中，提供各類事件資料觸發通知及上傳的設定條款，如行駛狀態、引擎狀態、速度事件、外接設備等項目。</p>
                  </li>
                  <li>
                    <p>（15） 系統設定 – 自定義內容</p>
                    <p>於本網站的「自定義內容」功能中，提供「任務種類、部門」等項目的設定使用。</p>
                  </li>
                </ul>
              </li>
            </ul>
          </div> 
          <div class="item">
            <h3>服務暫停或中斷</h3>
            <p>本公司將以合理之方式及技術，維護本服務之正常運作，但如有下列情 形之一時，本公司得暫停或中斷本服務之全部或部分，對於使用者不負擔任何賠償責任：</p>
            <ul style="list-style: decimal; padding-left: 18px;">
              <li>訂購平台服務到期未續約付款時。</li>
              <li>對於相關系統設備進行遷移、更換或維護時。</li>
              <li>因不可歸責於本公司所造成服務停止或中斷時。</li>
              <li>對設備進行必要之保養及施工時。</li>
              <li>發生突發性之設備故障時。</li>
              <li>現場網路異常時。</li>
              <li>非本公司所得控制之事由而致您的服務資訊顯示不正確、或遭偽造、竄改、刪除或擷取時。</li>
              <li>您有任何違反政府法令或本服務條款時。</li>
            </ul>
            <p>若因服務到期未續約付款，導致系統會自動關閉服務，此時房東及管理者可登入，但需要進行續約並繳費後才會開通服務功能。關閉服務期間系統會持續對電表(房間)進行連線及讀表，故費用仍以合約到期日開始計算。</p>
            <a class="greendeep" v-bind:href="url" target="_blank">隱私權聲明請參考</a>
          </div> 
          <div class="item">
            <h3>會員條款之修改</h3>
            <p>本公司保留隨時修改本服務條款之權利，修正後之服務條款將於本網站相關網頁公告，並自公告之日起即時生效，不另作個別通知。建議您經常瀏覽本網站以掌握最新聲明。若您於本服務條款修正更新後、繼續使用本網站服務，視同您同意本服務條款之修改。</p>
          </div>
          <div class="item">
            <h3>服務中止與修改</h3>
            <p>本公司保留隨時中止、更改各項服務內容，或終止任一會員帳戶服務之權利。無論任何情形就中止、更改服務或終止會員帳戶服務之決定。本公司對會員或第三人均不負任何賠償或補償責任，您應瞭解並同意本公司可能因公司、其他協力廠商或相關電信業者網路系統、軟硬體設備之故障、失靈、人為操作之疏失而全部或部份中斷、暫時無法使用、遲延或造成資料傳輸或儲存上之錯誤或遭第三人侵入系統篡改或偽造變造資料等，本公司不負任何賠償責任。</p>
            <p>您瞭解本公司提供本網站服務供會員使用，但不對任何服務或資訊傳送的遲延、儲存的故障以及任何資訊的刪除負任何責任。</p>
          </div>
          <div class="item">
            <h3>保管及通知義務</h3>
            <p>您有義務妥善保管在本網站註冊之帳號與密碼，且應為以此組帳號與密碼登入本網站後所進行之一切行為負責。為維護您自身權益，請勿將帳號與密碼洩露或提供予第三人知悉或出借、轉讓他人使用。若因您保管疏失而導致帳號、密碼遭他人非法使用時，本公司將不負責賠償責任。若您發現帳號或密碼遭人非法使用或有任何異常破壞使用安全之情形時，應立即通知本公司。若因未及時通知本公司以致無法有效防止或修護時，應自負全責。</p>
          </div>
          <div class="item">
            <h3>風險承擔</h3>
            <p>您同意使用本網站各項服務係基於個人意願，並同意自負任何風險。</p>
          </div>
          <div class="item">
            <h3>損害賠償</h3>
            <p>若您違反相關法令或違背本服務條款之任一條款，致本公司或其關係企業、受僱人、受託人、代理人及其他相關履行輔助人因此而受有損害或支出費用（包括但不限於因進行民事、刑事及行政程序所支出之律師費用等）時，您應負擔損害賠償責任或補償其費用。</p>
          </div>
          <div class="item">
            <h3>擔保責任免除及責任限制</h3>
            <ul style="list-style: decimal; padding-left: 18px;">
              <li>本網站如提供第三方網站的連結，目的僅為方便您使用，不代表該第三方網站的內容為本公司所認可與負責。如果您連結至第三方網站或廣告而因此產生的風險，應自行負責，本公司不為您與任何廣告商或第三方網站經營者之間的任何交易承擔任何責任。</li>
              <li>本公司就本網站提供之各項服務不負擔任何明示或默示之擔保責任，亦不保證各項服務之穩定、安全、無誤及不中斷。</li>
              <li>本公司不保證使用本網站服務之結果或經由本網站獲得之資訊符合您之期望，亦不保證您不會因此接觸到不適當之內容。</li>
              <li>本公司對於您使用本網站服務，或無法使用本網站服務所致之任何直接、間接衍生或特別損害、損失或費用，不負任何賠償責任。上述賠償責任限制，若依法為不得限制者，則限制規定將不予適用。</li>
            </ul>
          </div>
          <div class="item">
            <h3>個別條款之效力</h3>
            <p>本服務條款之全部或部分無效時，不影響其他條款之效力。</p>
          </div>
          <div class="item">
            <h3>通知</h3>
            <p>您依本服務條款之約定而有通知本公司之必要時，請電洽本公司（與本公司之連繫電話為：0800-221345），在本公司未收到會員通知前，尚未發生通知之效力，原約定不會因此而變更或受到任何影響。</p>
          </div>
          <div class="item">
            <h3>準據法及管轄法院</h3>
            <p>本服務條款之解釋及適用，以及您因使用本網站服務而與本公司間所生之權利義務關係，應依中華民國法令解釋適用之，若有涉訟或爭議，均同意以臺灣臺北地方法院為第一審管轄法院。</p>
          </div>
        </div>
      </a-col>
</template>
<script>
export default {
  name:'ProvisioningTerms',
  data() {
    return {
      url:`${process.env.VUE_APP_FMS_URL}/privacy`
    }
  }
}
</script>
<style lang="scss" scoped>
  .provisioning_agree_container {
    background-color: #f5f5f5;
    border: 2px solid #EAF6C9;
    height: 273px;
    overflow-y: auto;
    padding: 10px;
    resize: none;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
  }
  .provisioning_agree_container p {
    text-align: justify;
    margin-bottom: 0px;
  }
  .item {
    position: relative;
    margin-top: 16px;
  }
  .item:before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #343741;
    position: absolute;
    top: 9px;
    left: 0px;
    z-index: 1;
  }
  h3 {
    font-size: 14px;
    line-height: 21px;
    font-weight: 700;
    margin-bottom: 8px;
    position: relative;
    background-color: #f7f7f8;
    padding-right: 10px;
    display: inline-block;
    z-index: 2;
  }
  p,ul {
    margin-bottom: 0px;
  }
  ul li { text-align: justify; }
  a {
    margin-top: 16px;
    display: inline-block;
    text-decoration: underline;
    color: #8BB51E;
  }

</style>